import React, { Component } from "react";
import PropTypes from "prop-types";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { BeautyProfileQuestion } from "components/person/BeautyProfileQuestion";
import { CtrlCollection } from "@yuigoto/ctrl";
import { BeautyProfileControl } from "controls/BeautyProfileControl";
import { connect } from "react-redux";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { PersonActions } from "state/actions/user/PersonActions";
import { UiActions } from "state/actions/UiActions";
import classnames from "classnames";
import { SanitizeToDigits } from "@yuigoto/validators/dist/utils/Utils";
import { Question } from "components/feedback/Question";
import { GlamboxCookieStore } from "core/glambox/GlamboxCookieStore";

export class BeautyProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: [],
      activeQuestions: [],
      currentQuestion: 0,
      finished: false,

      loaded: false,

      current: 0,
      min: 0,
      max: null,

      profileStart: (props.skipFirstStep === true),
      profileFinish: false,

      bald: false,
      baldQuestion: 3,
      foward: true,
      skipList: [4, 5, 6, 7]
    };

    this.collection = new CtrlCollection();
    let { person } = this.props;

    for (let i = 0; i < BeautyProfileControl.length; i++) {
      let name,
        alias;

      if (Array.isArray(BeautyProfileControl[i])) {
        let tempCollection = new CtrlCollection();

        for (let n = 0; n < BeautyProfileControl[i].length; n++) {
          name = BeautyProfileControl[i][n].name;
          alias = BeautyProfileControl[i][n].alias;

          if (person[name] !== null && person[name] !== undefined || person[alias] !== null && person[alias] !== undefined) {
            
            if (/cpf/gi.test(name) || /cpf/gi.test(alias)) {
              let val = person[name] || person[alias];
              if (typeof val === "number") val = val.toString();

              if (val && val.length < 11) {
                while (val.length < 11) {
                  val = "0" + val;
                }
              }
  
              BeautyProfileControl[i][n].value = val;
            } else
              BeautyProfileControl[i][n].value = person[name] || person[alias];
          }

          tempCollection.add(BeautyProfileControl[i][n]);
        }
        this.collection.add(tempCollection);
      } else {
        let name = BeautyProfileControl[i].name,
          alias = BeautyProfileControl[i].alias;

        if (person[name] !== null && person[name] !== undefined || person[alias] !== null && person[alias] !== undefined) {
          BeautyProfileControl[i].value = person[name] || person[alias];
        }

        this.collection.add(BeautyProfileControl[i]);
      }
    }

    this.renderQuestions = this.renderQuestions.bind(this);
    this.updateQuestion = this.updateQuestion.bind(this);
    this.navigateThroughForm = this.navigateThroughForm.bind(this);
    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.sendBeautyProfile = this.sendBeautyProfile.bind(this);
    this.createAnswers = this.createAnswers.bind(this);
    this.countChecked = this.countChecked.bind(this);
  }

  componentDidMount() {
    const { beautyProfile } = this.props;

    if (beautyProfile) {
      let questions = [];

      for (let q in beautyProfile) {
        for (let a in beautyProfile[q].attributes) {
          questions.push(
            beautyProfile[q].attributes[a]
          );
        }
      }

      this.setState({
        questions: questions,
        max: questions.length,
        loaded: true
      });
    } else {
      this._fetchQuestionsData();
    }
  }

  countChecked() {
    let { questions, currentQuestion } = this.state;
    let checkedCount = 0;

    if (!questions[currentQuestion]) return null;

    return checkedCount = questions[currentQuestion].options.filter((item) => {
      return item.checked;
    }).length;
  }

  updateQuestion(question, moveFoward) {
    let { questions, bald } = this.state;
    let baldRegex = /careca/ig;

    question.options.forEach((item) => {
      if (baldRegex.test(item.name)){
        this.setState({ bald: item.checked });
      }
    });

    for (let n = 0; n < questions.length; n++) {
      let current = questions[n];
      if (current.id === questions.id) {
          questions[n] = question;
      }
    }

    this.setState({
      questions,
      currentQuestion: moveFoward ? this.state.currentQuestion + 1 : this.state.currentQuestion,
      current: moveFoward ? this.state.current + 1 : this.state.current
    });
  }

  navigateThroughForm(i) {
    return () => {
      this.setState({
        current: this.state.currentQuestion + i,
        currentQuestion: this.state.currentQuestion + i
      });
    }
  }

  updateUserInfo(event) {
    event.preventDefault();

    let isValid = this.collection.validate();

    if (!isValid) {
      this.forceUpdate();
    } else {
      let personData = this.collection.toObject(true),
        birth = new Date(
          personData.birthday.split("/").reverse().join("/") + " 00:00:00"
        );

      personData.birthday = birth.toLocaleDateString();
      personData.cpf = SanitizeToDigits(personData.cpf);

      this.props.personUpdate(
        Object.assign(
          {},
          personData
        ),
        (response) => {
          const {
            result,
            statusCode
          } = response;

          if (statusCode === 200) {
            this.sendBeautyProfile();
          } else {
            this.props.errorAlert(
              (result && result.message)
                ? result.message
                : "Não possível enviar o seu perfil de beleza."
            );
          }
        }
      );
    }
  }

  checkHairCondition = () => {
    let {bald, current, foward, questions, skipList} = this.state;
    let baldRegex = /careca/ig;

    if(questions[current] !== undefined)
      questions[current].options.forEach((item) => {
        if (baldRegex.test(item.name) && bald===false){
          item.checked = false;
        }
      });

    if(bald && skipList.includes(current)){
      questions[current].options.forEach((item) => {
        item.checked = false;
      });
      if(foward){
        this.setState({current:current+1})
      } else{
        this.setState({current:current-1})
      } 
    }
  }

  createAnswers() {
    let { questions } = this.state;
    let answersToSend = [];

    for (let i = 0; i < questions.length; i++) {
      let q = questions[i], answers = [], resp = "";

      for (let j = 0; j < q.options.length; j++) {
        if (q.options[j].checked) {
          answers.push(q.options[j].id);
        }
      }
      resp = answers.join();
      answersToSend[q.id] = resp;
    }
    return answersToSend;
  };

  sendBeautyProfile() {
    const {
      token
    } = this.props;

    const answers = this.createAnswers();

    ExecuteRequest(
      GlamboxEndpoints.BeautyProfile.beautyProfileCreate,
      Object.assign({}, answers),
      "POST",
      {
        Authorization: token.Authorization
      },
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;

        let cookieHandle = new GlamboxCookieStore(
          "/",
          process.env.REACT_APP_GB_COOKIE_ROOT,
          false,
          new Date(Date.now() + (60 * 60 * 3 * 1000))
        );

        cookieHandle.set("beautyProfileAnswered", 1);

        if (statusCode === 200) {
          this.props.successAlert(
            result && result.message
              ? result.message
              : "Perfil de beleza atualizado com sucesso."
          );

          this.setState({
            profileFinish: true
          });

          if (this.props.onFinish) this.props.onFinish();
        } else {
          this.props.errorAlert(
            result && result.message
              ? result.message
              : "Não foi possível atualizar os dados de seu perfil de beleza. Por favor, tente novamente."
          );
        }
      }
    );
  }

  render() {

    if (!this.state.loaded) {
      return (
        <div className={"beautyProfileModal"}>
          <p className={"text-center p-3"}>
            Carregando...
          </p>
        </div>
      );
    }

    if (!this.state.questions || this.state.questions.length === 0) return null;

    return (
      <div className={"beautyProfileModal"}>
        <div className={"progressIcons"}>
          {this._renderProgress()}
        </div>
        {this.state.currentQuestion < this.state.questions.length
          ? <h1>Perfil de Beleza</h1>
          : null}
        {this.renderQuestions()}
        {this.renderNavigation()}
      </div>
    );
  }

  // --------------------------------------------------------------------

  _fetchQuestionsData = () => {
    const {
      token
    } = this.props;

    this.setState({
      loaded: false
    });

    ExecuteRequest(
      GlamboxEndpoints.BeautyProfile.beautyprofile,
      {},
      "GET",
      {
        Authorization: token.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          let questions = [];

          for (var i = 0; i < result.length; i++) {
            for (var j = 0; j < result[i].attributes.length; j++) {
              questions.push(result[i].attributes[j]);
            }
          }

          this.setState({
            questions,
            max: questions.length,
            loaded: true
          });
        }
      });
  };

  _renderStart = () => {
    return (
      <div>
        <h4>Complete o seu</h4>
        <h2 className={'display-2 text-center'}>Perfil de Beleza</h2>
        <p className={"lead mb-4"}>Queremos saber mais sobre você!</p>
      </div>
    )
  };

  _renderThanks = () => {
    return (
      <div>
        <h4>Obrigada por completar o seu Perfil de Beleza!</h4>
      </div>
    )
  };

  _renderProgress = () => {
    let {
      current,
      min,
      max,
      profileStart,
      profileFinish,
      bald,
      skipList
    } = this.state;
    let spots = [];

    if (profileFinish || !profileStart || current >= max) return null;

    for (let n = min; n < max; n++) {
      let _cls = ["progressIcon"];
      if (current === n) {
        _cls.push("current");
      } else {
        if (this._isChecked(n) > 0 && n > current) {
          _cls.push("active");
        }
      }

      spots.push(<span key={n} className={classnames(_cls)} />);
    }

    return spots;
  };

  renderQuestions = () => {
    let {
      questions,
      current,
      min,
      max,
      profileStart,
      profileFinish
    } = this.state;

    this.checkHairCondition();

    if (profileStart === false) return this._renderStart();
    if (profileFinish === true) return this._renderThanks();

    if (current < min) {
      return (
        <div>
          <p>Vamos?</p>
        </div>
      );
    } else if (current >= max) {
      return (
        <div>
          <div className={"display-3"}>Falta pouco...</div>
          <p className={"pb-2"}>Complete os campos abaixo para concluir seu cadastro:</p>
          <form className={"container text-left"} onSubmit={this.updateUserInfo}>
            {ControlRenderer.renderCollection(this.collection)}
          </form>
        </div>
      );
    } else {
      return (
        <BeautyProfileQuestion
          question={questions[current]}
          callback={this.updateQuestion} />
      );
    }
  };

  renderNavigation = () => {
    return (
      <div className={"modal_beautyProfile_controlle"}>
        {this._renderNavigationPrev()}
        &nbsp;
        {this._renderNavigationNext()}
      </div>
    );
  };

  _renderNavigationPrev = () => {
    if (
      this.state.profileStart === false
      || this.state.profileFinish === true
    ) return null;

    if (this.props.skipFirstStep && this.state.current === 0) return null;

    return (
      <button
        id={"Voltar"}
        className={"btn btn-light-pink"}
        onClick={this._navigateTo(-1)}>
        Voltar
      </button>
    );
  };

  _renderNavigationNext = () => {
    let {
      current,
      min,
      max,
      profileStart,
      profileFinish
    } = this.state;
    let _cls = ["btn"];

    if (
      profileFinish === true
    ) return null;

    if (current < max) {
      _cls.push("btn-light-lime");
      let disabled = (
        profileStart
        && this._isChecked(current) < 1
      );

      if (profileStart === false) {
        return (
          <button
            id={"Avançar"}
            className={classnames(_cls)}
            disabled={disabled}
            onClick={this._navigateTo(1)}>
            Começar
          </button>
        );
      }

      return (
        <button
          id={"Avançar"}
          className={classnames(_cls)}
          disabled={disabled}
          onClick={this._navigateTo(1)}>
          Próxima
        </button>
      );
    } else {
      _cls.push("btn-light-lime");

      return (
        <button
          id={"Avançar"}
          className={classnames(_cls)}
          onClick={this.updateUserInfo}>
          Enviar
        </button>
      );
    }
  };

  _navigateTo = (direction) => {
    return () => {
      let {
        current,
        currentQuestion,
        min,
        max,
        profileStart,
        profileFinish
      } = this.state;

      if(direction === -1){
        this.setState({foward : false})
      }else{
        this.setState({foward : true})
      }

      if (currentQuestion + direction < min) {
        currentQuestion = 0;
        current = 0;
        profileStart = false;
      } else {
        if (profileStart === false) {
          profileStart = true;
        } else {
          current += direction;
          currentQuestion += direction;
        }
      }

      if (currentQuestion + direction < max) {
        profileFinish = false;
      }

      this.setState({
        current,
        currentQuestion,
        profileStart,
        profileFinish
      });

      this.forceUpdate();
    };
  };

  _isChecked = (question) => {
    let { questions } = this.state;

    if (!questions[question]) return false;

    return questions[question]
      .options
      .filter((item) => {
        return item.checked;
      }).length;
  };
}

BeautyProfile.propTypes = {
  skipFirstStep: false
};

BeautyProfile.propTypes = {
  skipFirstStep: PropTypes.bool
};

const mapStateToProps = (state) => ({
  token: state.token.data,
  person: state.person.data.person,
  beautyProfile: state.beautyProfile.data
});

const mapDispatchToProps = (dispatch) => {
  return {
    personUpdate: (person, callback) => {
      dispatch(PersonActions.updatePerson(person, callback))
    }
    , successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    }
    , errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    }
  }
};

BeautyProfile = connect(mapStateToProps, mapDispatchToProps)(BeautyProfile);
